import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "balances-list-exchange-wrapper"
}
const _hoisted_2 = { class: "balances-item__cell__code-wrapper" }
const _hoisted_3 = { class: "balances-item__cell__code" }
const _hoisted_4 = { class: "balances-item__cell__name" }
const _hoisted_5 = { class: "balances-list-exchange__add-funds" }

import { OtIcon } from '@1trading/design-system';
import { computed, onMounted, ref, type PropType } from 'vue';
import { useI18n } from 'vue-i18n';

import type { BalanceModel } from '@exchange/libs/balances/service/src';
import XButton from '@exchange/libs/components/x-components/src/lib/XButton.vue';
import XLogo from '@exchange/libs/components/x-components/src/lib/XLogo.vue';
import { marginService } from '@exchange/libs/futures/service/src';
import { CURRENCY_ELIGIBLE_FOR_MARGIN } from '@exchange/libs/futures/service/src/lib/constants.config';
import { createDivTableColumnInstance } from '@exchange/libs/order/my-orders/ui/src/lib/components/div-table-helpers';
import DivTable from '@exchange/libs/order/my-orders/ui/src/lib/components/DivTable.vue';
import DivTableCell from '@exchange/libs/order/my-orders/ui/src/lib/components/DivTableCell.vue';
import DivTableRow from '@exchange/libs/order/my-orders/ui/src/lib/components/DivTableRow.vue';
import { CONSTANTS } from '@exchange/libs/utils/constants/src';
import { currencyService } from '@exchange/libs/utils/currency/src';

import BalancesInfoMessageBlock from './BalancesInfoMessageBlock.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BalancesListExchangeDesktop',
  props: {
  authenticatedUser: { type: Boolean, required: true },
  historySource: { type: Object as PropType<HistoryDataSource>, required: true },
  sortedList: { type: Array as PropType<BalanceModel[]>, required: true },
},
  emits: ["deposit", "transfer"],
  setup(__props, { emit: __emit }) {

const { t } = useI18n({ useScope: 'global' });



const emit = __emit;

const balanceContainerContentRef = ref<HTMLElement>();
const balanceContainerContentTop = ref<number>();

const { getCurrencyName } = currencyService;
const { balance: marginBalance, equity, marginUsedPercentage } = marginService;

onMounted(() => {
  if (!balanceContainerContentRef.value) {
    return;
  }

  const { top } = balanceContainerContentRef.value.getBoundingClientRect();

  balanceContainerContentTop.value = top;
});

const balancesHeaders = computed(() => [
  createDivTableColumnInstance({
    title: t('modules.myOrders.header.asset'),
    columnClass: 'asset align-left',
    sortFunction: () => 0,
    sorted: false,
    sortDirection: 'asc',
    hidden: false,
  }),
  createDivTableColumnInstance({
    title: t('modules.myOrders.header.totalBalance'),
    columnClass: 'available align-left',
    sortFunction: () => 0,
    sorted: false,
    sortDirection: 'asc',
    hidden: false,
  }),
  createDivTableColumnInstance({
    title: t('modules.myOrders.header.availableMargin'),
    columnClass: 'in-order align-left',
    sortFunction: () => 0,
    sorted: false,
    sortDirection: 'asc',
    hidden: false,
  }),
  createDivTableColumnInstance({
    title: t('modules.myOrders.header.usedMargin'),
    columnClass: 'in-order align-left',
    sortFunction: () => 0,
    sorted: false,
    sortDirection: 'asc',
    hidden: false,
  }),
  createDivTableColumnInstance({
    title: t('modules.myOrders.header.usedForMargin'),
    columnClass: 'in-order align-left',
    sortFunction: () => 0,
    sorted: false,
    sortDirection: 'asc',
    hidden: false,
  }),
  createDivTableColumnInstance({
    title: t('modules.myOrders.header.eligibleForCollateral'),
    columnClass: 'in-order align-left',
    sortable: false,
    sortFunction: () => 0,
    sorted: false,
    sortDirection: 'asc',
    hidden: false,
  }),
  createDivTableColumnInstance({
    title: '',
    columnClass: 'in-order align-right',
    sortable: false,
    sortFunction: () => 0,
    sorted: false,
    sortDirection: 'asc',
    hidden: false,
  }),
]);

const gridColumnsStyle = computed(() => ({ 'grid-template-columns': '1fr 1fr 1fr 1fr 1fr 1fr 1fr' }));

return (_ctx: any,_cache: any) => {
  return (!__props.sortedList.length || !__props.authenticatedUser)
    ? (_openBlock(), _createBlock(BalancesInfoMessageBlock, {
        key: 0,
        "authenticated-user": __props.authenticatedUser
      }, null, 8, ["authenticated-user"]))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(DivTable, {
          class: "balances-list-exchange",
          header: balancesHeaders.value,
          rows: __props.sortedList,
          "sticky-header": true,
          style: _normalizeStyle(gridColumnsStyle.value),
          onHeaderChanged: () => {}
        }, {
          default: _withCtx(({}) => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.sortedList, (balance) => {
              return (_openBlock(), _createBlock(DivTableRow, {
                key: balance.currencyCode,
                class: "balances-item",
                "data-id": balance.currencyCode,
                style: _normalizeStyle(gridColumnsStyle.value)
              }, {
                default: _withCtx(() => [
                  _createVNode(DivTableCell, { class: "balances-item__cell asset align-left" }, {
                    default: _withCtx(() => [
                      _createVNode(XLogo, {
                        class: "balances-item__cell__icon",
                        name: balance.currencyCode,
                        type: "crypto"
                      }, null, 8, ["name"]),
                      _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("span", _hoisted_3, _toDisplayString(balance.currencyCode), 1),
                        _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(getCurrencyName)(balance.currencyCode)), 1)
                      ])
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(DivTableCell, { class: "balances-item__cell available align-left" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(balance.currencyCode === _unref(CURRENCY_ELIGIBLE_FOR_MARGIN) ? _unref(equity).toFixed(_unref(CONSTANTS).PRECISION.DEFAULT_FIAT) : balance.total), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(DivTableCell, { class: "balances-item__cell in-order align-left" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(balance.currencyCode === _unref(CURRENCY_ELIGIBLE_FOR_MARGIN) ? _unref(marginBalance).available.toFixed(_unref(CONSTANTS).PRECISION.DEFAULT_FIAT) : balance.available), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(DivTableCell, { class: "balances-item__cell in-order align-left" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(balance.currencyCode === _unref(CURRENCY_ELIGIBLE_FOR_MARGIN) ? _unref(marginBalance).used.toFixed(_unref(CONSTANTS).PRECISION.DEFAULT_FIAT) : balance.locked), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(DivTableCell, { class: "balances-item__cell in-order align-left" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(balance.currencyCode === _unref(CURRENCY_ELIGIBLE_FOR_MARGIN) ? _unref(marginUsedPercentage) + '%' : '0%'), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(DivTableCell, { class: "balances-item__cell in-order align-left" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(balance.currencyCode === _unref(CURRENCY_ELIGIBLE_FOR_MARGIN) ? 'Yes' : 'No'), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(DivTableCell, { class: "balances-item__cell__actions in-order align-right" }, {
                    default: _withCtx(() => [
                      _createVNode(XButton, {
                        class: "balances-item__cell__action-button",
                        size: "3xs",
                        variant: "tertiary",
                        onClick: () => emit('deposit', balance.currencyCode)
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(OtIcon), { name: "add-square" })
                        ]),
                        _: 2
                      }, 1032, ["onClick"]),
                      _createVNode(XButton, {
                        class: "balances-item__cell__action-button",
                        size: "3xs",
                        variant: "tertiary",
                        onClick: () => emit('transfer', balance.currencyCode)
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(OtIcon), { name: "arrow-swap-horizontal" })
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1032, ["data-id", "style"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["header", "rows", "style"]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(XButton, {
            variant: "primary",
            size: "sm",
            onClick: _cache[0] || (_cache[0] = () => emit('deposit'))
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Add funds ")
            ]),
            _: 1
          })
        ])
      ]))
}
}

})